module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_vm._v("Loading...")]), _vm._v(" "), _c('section', {
    staticClass: "serverapp"
  }, [_c('header', {
    staticClass: "header"
  }, [_c('nav', {
    staticClass: "navbar navbar-expand-sm navbar-light bg-light"
  }, [_c('a', {
    staticClass: "navbar-brand"
  }, [_vm._v("Pivotal Board")]), _vm._v(" "), _c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projects),
      expression: "projects"
    }],
    staticClass: "form-inline"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projects),
      expression: "projects"
    }],
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.iterationCount),
      expression: "iterationCount"
    }],
    staticClass: "form-control",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "type": "number",
      "min": "1",
      "max": "9"
    },
    domProps: {
      "value": (_vm.iterationCount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.iterationCount = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projects),
      expression: "projects"
    }],
    staticClass: "nav nav-pills"
  }, _vm._l((_vm.projects), function(project, index) {
    return _c('li', {
      key: project.id,
      staticClass: "nav-item"
    }, [_c('a', {
      staticClass: "nav-link",
      class: {
        active: project == _vm.selectedProject
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.selectProject(project)
        }
      }
    }, [_vm._v(_vm._s(project.name))])])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.connected),
      expression: "!connected"
    }],
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.pivotToken),
      expression: "config.pivotToken"
    }],
    staticClass: "form-control",
    attrs: {
      "autofocus": "",
      "autocomplete": "off",
      "placeholder": "Enter token here"
    },
    domProps: {
      "value": (_vm.config.pivotToken)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.setToken()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config, "pivotToken", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ml-auto justify-content-end"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.connected),
      expression: "!connected"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setToken()
      }
    }
  }, [_vm._v("\n              Connect\n          ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.connected),
      expression: "connected"
    }],
    staticClass: "btn btn-light",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.disconnect()
      }
    }
  }, [_vm._v("\n              Disconnect\n          ")])])])]), _vm._v(" "), _c('main', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.connected),
      expression: "!connected"
    }],
    staticClass: "row"
  }, [_vm._m(3)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error.possible_fix),
      expression: "error.possible_fix"
    }],
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.error.error))]), _vm._v(" " + _vm._s(_vm.error.possible_fix) + "\n      ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error.message),
      expression: "error.message"
    }],
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.error.name))]), _vm._v(" " + _vm._s(_vm.error.message) + "\n      ")]), _vm._v(" "), _c('div', [_c('h1', [_vm._v("Stories")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.stories),
      expression: "stories"
    }],
    staticClass: "scrum-board"
  }, [_c('div', {
    staticClass: "scrum-group"
  }, [_c('h2', [_vm._v("Todo")]), _vm._v(" "), _vm._l((_vm.todoStories), function(story, index) {
    return _c('story-card', {
      key: story.id,
      attrs: {
        "story": story
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "scrum-group"
  }, [_c('h2', [_vm._v("Dev")]), _vm._v(" "), _vm._l((_vm.devStories), function(story, index) {
    return _c('story-card', {
      key: story.id,
      attrs: {
        "story": story
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "scrum-group"
  }, [_c('h2', [_vm._v("QA")]), _vm._v(" "), _vm._l((_vm.qaStories), function(story, index) {
    return _c('story-card', {
      key: story.id,
      attrs: {
        "story": story
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "scrum-group"
  }, [_c('h2', [_vm._v("Done")]), _vm._v(" "), _vm._l((_vm.doneStories), function(story, index) {
    return _c('story-card', {
      key: story.id,
      attrs: {
        "story": story
      }
    })
  })], 2)])]), _vm._v(" "), _vm._m(4)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Show")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Iterations")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Pivotal API Token")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    attrs: {
      "href": "https://www.pivotaltracker.com/profile"
    }
  }, [_vm._v("Get your API Token from your PivotalTracker Profile page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "ct-chart ct-square"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68776ea4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainPage.vue
// module id = 152
// module chunks = 1